import styled from 'styled-components';
import colors from 'constants/colors';

export const Head = styled.div`
  position: relative;
  font-size: 22px;
  font-weight: 600;
  color: ${colors.green};
  margin-bottom: 16px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  .modalText {
    font-size: 18px;
    font-weight: 600;
    color: ${colors.white};
    margin-bottom: 16px;
  }

  .highLight {
    color: ${colors.lightBlue};
    cursor: pointer;
    text-decoration: underline;
  }
`;

export const Footer = styled.div`
  font-weight: 300;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  padding-top: 24px;
`;
